import { create } from 'zustand';
import {
  AppointmentBookScheduleRequest,
  MedicalCare,
  PatientSchedule,
  Payment,
  Resource,
  Schedule,
  Service,
  Unit
} from '../../../models/AppointmentBookScheduleRequest';

interface IStore {
  schedule: AppointmentBookScheduleRequest;
  setSchedule: (prop: AppointmentBookScheduleRequest) => void;
}

export const store = create<IStore>(set => ({
  schedule: {} as AppointmentBookScheduleRequest,
  setSchedule: value => set(() => ({ schedule: value }))
}));

export const useSchedule = () => {
  const { setSchedule: saveSchedule, schedule: storeSchedule } = store();

  const schedule = { ...storeSchedule } as AppointmentBookScheduleRequest;

  const setResource = (resource: Resource) => (schedule.resource = resource);
  const setSchedule = (scheduleProps: Schedule) => (schedule.schedule = scheduleProps);
  const setService = (service: Service) => (schedule.service = service);
  const setPayment = (payment: Payment) => (schedule.payment = payment);
  const setPatient = (patient: PatientSchedule) => (schedule.patient = patient);
  const setChannel = (channel: string) => (schedule.channel = channel);
  const setUnit = (unit: Unit) => (schedule.unit = unit);
  const setMedicalCare = (care: MedicalCare) => (schedule.medicalCare = care);
  const build = () => saveSchedule(schedule);

  return {
    setService,
    setResource,
    setSchedule,
    setUnit,
    setPayment,
    setChannel,
    setPatient,
    schedule: storeSchedule,
    setMedicalCare,
    scheduleBuild: build
  };
};
